import { AnyAction } from 'redux';
import {  IPage } from '../../Models/Security';
import { ActionsAccount } from '../../Actions/Account/Types';
import { IAccount } from '../../Models/Account';
import { EStatusRequest } from '../Session';

export interface IAccountState {
	isFail: boolean;
	messageFail: string;
	isRequest: boolean;
	page: IPage<IAccount>;
	current?: IAccount;
	status: EStatusRequest;
}

const initialState = {
	isRequest: false,
	page: {
		meta: {
			total: 0,
			page: 0,
			size: 0,
			pages: 0
		},
		data: []
	},
	current: undefined,
	isFail: false,
	messageFail: '',
	status: EStatusRequest.PENDING
};

const asyncReducer = (
	state: IAccountState = initialState,
	action: AnyAction
) => {
	switch (action.type) {
		case ActionsAccount.REQUEST_ACCOUNT:
			return {...state, isRequest: !state.isRequest };
		case ActionsAccount.FETCH_ACCOUNT:
			const profile = action.payload as IAccount;
			return {...state, isFail: false, current: profile };
		case ActionsAccount.FETCH_ACCOUNTS:
			const pageFetch = action.payload as IPage<IAccount>;
			return {...state, isFail: false, page: pageFetch };
		case ActionsAccount.ERROR_ACCOUNT:
			return {...state, isFail: true, messageFail: action.payload };
		case ActionsAccount.CLEAN_CURRENT_ACCOUNT:
			return {...state, current: undefined };
		case ActionsAccount.CLEAN_STATUS_ACCOUNT:
				return {...state, status: EStatusRequest.PENDING };
		case ActionsAccount.STATUS_REQUEST_ACCOUNT:
			return {...state, status: action.payload };

	}
	return state;
};

export default asyncReducer;
